//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehiclePropValue.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VehiclePropertyStatus } from "./VehiclePropertyStatus_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropertyStatus } from "./VehiclePropertyStatus_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/VehiclePropValue.proto.
 */
export const file_android_hardware_automotive_vehicle_VehiclePropValue: GenFile = /*@__PURE__*/
  fileDesc("CjphbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlUHJvcFZhbHVlLnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byKDAgoQVmVoaWNsZVByb3BWYWx1ZRIRCgl0aW1lc3RhbXAYASABKAMSDwoHYXJlYV9pZBgCIAEoBRIMCgRwcm9wGAMgASgFElAKBnN0YXR1cxgEIAEoDjJALmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlZlaGljbGVQcm9wZXJ0eVN0YXR1cxIUCgxpbnQzMl92YWx1ZXMYBSADKAUSFAoMZmxvYXRfdmFsdWVzGAYgAygCEhQKDGludDY0X3ZhbHVlcxgHIAMoAxITCgtieXRlX3ZhbHVlcxgIIAEoDBIUCgxzdHJpbmdfdmFsdWUYCSABKAkiYAoRVmVoaWNsZVByb3BWYWx1ZXMSSwoGdmFsdWVzGAEgAygLMjsuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uVmVoaWNsZVByb3BWYWx1ZWIGcHJvdG8z", [file_android_hardware_automotive_vehicle_VehiclePropertyStatus]);

/**
 * Must be in sync with VehiclePropValue.aidl. 
 *
 * @generated from message android.hardware.automotive.vehicle.proto.VehiclePropValue
 */
export type VehiclePropValue = Message<"android.hardware.automotive.vehicle.proto.VehiclePropValue"> & {
  /**
   * Time is elapsed nanoseconds since boot 
   *
   * @generated from field: int64 timestamp = 1;
   */
  timestamp: bigint;

  /**
   * Area type(s) for non-global property it must be one of the value from
   * VehicleArea* enums or 0 for global properties. 
   *
   * @generated from field: int32 area_id = 2;
   */
  areaId: number;

  /**
   * Property identifier 
   *
   * @generated from field: int32 prop = 3;
   */
  prop: number;

  /**
   * Status of the property 
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.VehiclePropertyStatus status = 4;
   */
  status: VehiclePropertyStatus;

  /**
   * This is used for properties of types VehiclePropertyType#INT
   * and VehiclePropertyType#INT_VEC 
   *
   * @generated from field: repeated int32 int32_values = 5;
   */
  int32Values: number[];

  /**
   * This is used for properties of types VehiclePropertyType#FLOAT
   * and VehiclePropertyType#FLOAT_VEC 
   *
   * @generated from field: repeated float float_values = 6;
   */
  floatValues: number[];

  /**
   * This is used for properties of type VehiclePropertyType#INT64 
   *
   * @generated from field: repeated int64 int64_values = 7;
   */
  int64Values: bigint[];

  /**
   * This is used for properties of type VehiclePropertyType#BYTES 
   *
   * @generated from field: bytes byte_values = 8;
   */
  byteValues: Uint8Array;

  /**
   * This is used for properties of type VehiclePropertyType#STRING 
   *
   * @generated from field: string string_value = 9;
   */
  stringValue: string;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehiclePropValue.
 * Use `create(VehiclePropValueSchema)` to create a new message.
 */
export const VehiclePropValueSchema: GenMessage<VehiclePropValue> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValue, 0);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.VehiclePropValues
 */
export type VehiclePropValues = Message<"android.hardware.automotive.vehicle.proto.VehiclePropValues"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.VehiclePropValue values = 1;
   */
  values: VehiclePropValue[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehiclePropValues.
 * Use `create(VehiclePropValuesSchema)` to create a new message.
 */
export const VehiclePropValuesSchema: GenMessage<VehiclePropValues> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValue, 1);

